import { Offers } from "modules/offers";

const OffersPage = () => {
  return <Offers />;
};

export default OffersPage;
